/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CurrencySettingsResponse {
  currency?: string;
  date?: number;
  oficialExchangeRate?: number;
  spread?: number;
  iof?: number;
  operacionalMargin?: number;
  pixProcessmentFee?: number;
  cardProcessmentFee?: number;
  debitCardProcessmentFee?: number;
  antecipationFee?: number;
  financingFee?: number;
  twoMonthsFee?: number;
  threeMonthsFee?: number;
  fourMonthsFee?: number;
  fiveMonthsFee?: number;
  sixMonthsFee?: number;
  sevenMonthsFee?: number;
  eightMonthsFee?: number;
  nineMonthsFee?: number;
  tenMonthsFee?: number;
  elevenMonthsFee?: number;
  twelveMonthsFee?: number;
}
